import { Action, createReducer, on } from '@ngrx/store'
import { CommonState, initialCommonState } from '../state/common.state'
import { SAVE_SUMMARY_TABLE_SEARCH_PARAMS } from '../action/common/common.action'

export function commonReducer(state: CommonState, action: Action) {
  return _commonReducer(state, action)
}

const _commonReducer = createReducer(
  initialCommonState,
  on(SAVE_SUMMARY_TABLE_SEARCH_PARAMS, (state, { owner, data }) => {
    const updatedSummary = state?.summaryTableData?.set(owner, data)
    return {
      ...state,
      summaryTableData: updatedSummary
    }
  })
)
